<template>

  <BasicLayout>

    <ItemPage :options="options"
              :items="items"
              :quickSearchPlaceholder="'Search by PreferredUsername'"
              :searchData="searchData"
              :quickSearch="quickSearch"></ItemPage>

    <v-snackbar v-model="displaySnackBarMessage" :timeout="15000">{{ snackBarMessage }}
      <v-btn color="blue" text="text" @click="displaySnackBarMessage = false">CLOSE</v-btn>
    </v-snackbar>

    <PremiumManager ref="premiumManager"
                    :toggled="managePremiumToggled"
                    :user="managePremiumUser"
                    @setUserPremium="setUserPremium"
                    @unsetUserPremium="unsetUserPremium"
                    @closePremiumManager="closePremiumManager"/>

    <!-- LOADER -->
    <LoadingPopup :displayed="loaderDisplayed" :title="loaderTitle" :text="loaderText" />

  </BasicLayout>

</template>

<script>

import BasicLayout from '@/layouts/BasicLayout'
import ItemPage from '@/components/common/ItemPage'
import ItemID from '@/components/links/ItemID'
import PremiumManager from '@/components/PremiumManager'
import { mapGetters } from 'vuex'
import LoadingPopup from '../components/common/LoadingPopup.vue'

export default {
  name: 'Users',
  components: {
    LoadingPopup,
    BasicLayout,
    ItemPage,
    PremiumManager
  },
  data () {
    return {
      itemIDs: [],
      options: {
        title: 'Users',
        // applyEdit: this.edit,
        applyDelete: this.del,
        editable: false,
        deletable: true,
        itemActions: [
          {
            icon: 'mdi-crown',
            title: 'Manage Premium status',
            onclick: this.togglePremiumManager
          }
        ],
        columns: [
          {
            text: 'ID',
            value: 'id',
            displayComponent: ItemID,
            editable: false,
            searchable: true
          },
          {
            text: 'Preferred Username',
            value: 'preferredUsername',
            editable: false,
            searchable: true
          },
          {
            text: 'Email',
            value: 'email',
            placeholer: 'example@rematch.fr',
            editable: false
          },
          {
            text: 'Registration',
            value: 'registrationDate',
            displayRender: d => new Date(d).toLocaleString(`${this.$localeRegion}-${this.$country}`),
            searchable: false,
            editable: false
          },
          {
            text: 'Level',
            value: 'level',
            editable: false
          }
          // SEARCH BY DATE RANGE
        ]
      },
      managePremiumToggled: false,
      managePremiumUser: null,
      displaySnackBarMessage: false,
      snackBarMessage: '',
      confirmRemovalUsername: false,

      loaderDisplayed: false,
      loaderTitle: null,
      loaderText: null
    }
  },
  computed: {
    ...mapGetters(['userByIDs']),

    items () {
      return this.userByIDs(this.itemIDs)
    }
  },
  methods: {
    searchData (params) {
      return new Promise((resolve, reject) => {
        if (params.date) {
          params.startDate = params.date.from
          params.endDate = params.date.to
          delete params.date
        }

        params.withTotalItems = true

        this.$store.dispatch('searchUsers', params)
          .then(resp => {
            this.itemIDs = resp.items.map(i => i.id)
            resolve(resp.totalItems)
          })
          .catch(err => {
            console.error('Failed to load users: ', err)
            this.itemIDs = []
            reject(err)
          })
      })
    },

    quickSearch (input) {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('searchUsers', {preferredUsername: input})
          .then(resp => {
            this.itemIDs = resp.items.map(i => i.id)
            resolve(resp.totalItems)
          })
          .catch(err => {
            console.error('Failed to load user:', err)
            this.itemIDs = []
            reject(err)
          })
      })
    },

    create () {
      console.log('Not implemented yet')
    },

    edit (item) {
      return this.$store.dispatch('patchUser', {
        id: item.id,
        patch: item
      })
    },

    del (item) {
      return this.$store.dispatch('deleteUser', {
        id: item.id,
        confirm: this.confirmRemovalUsername === item.id
      })
        .then(resp => {
          this.snackBarMessage = resp.data.status
          this.displaySnackBarMessage = true
        })
        .catch(err => {
          if (err.response.status === 409) {
            this.snackBarMessage = err.response.data.status
            this.displaySnackBarMessage = true
            this.confirmRemovalUsername = item.id
          } else {
            this.snackBarMessage = 'Error trying to delete user'
            this.displaySnackBarMessage = true
          }
        })
    },

    togglePremiumManager (item) {
      this.$store.dispatch('getUser', item.id)
        .then(resp => {
          if (resp.isPremium && !item.is_premium_indefinitely) {
            alert('User already has a standard Rematch Premium Subscription.\nYou can only add Custom Premium to non-premium users.')
          } else {
            this.managePremiumUser = JSON.parse(JSON.stringify(item))
            this.managePremiumToggled = true
          }
        })
        .catch(() => {
          alert('Error getting user')
        })
    },
    closePremiumManager () {
      this.managePremiumToggled = false
      this.managePremiumUser = null
    },

    setUserPremium (userid) {
      this.displayLoader({
        title: 'Updating Premium status...'
      })
      this.$store.dispatch('setUserPremium', userid)
        .then(() => {
          this.searchData({})
          this.$refs.premiumManager.close()
          this.hideLoader()
        })
        .catch(() => {
          alert('Error updating Premium status')
          this.$refs.premiumManager.close()
          this.hideLoader()
        })
    },
    unsetUserPremium (userid) {
      this.displayLoader({
        title: 'Updating Premium status...'
      })
      this.$store.dispatch('unsetUserPremium', userid)
        .then(() => {
          this.searchData({})
          this.$refs.premiumManager.close()
          this.hideLoader()
        })
        .catch(() => {
          alert('Error updating Premium status')
          this.$refs.premiumManager.close()
          this.hideLoader()
        })
    },

    displayLoader (content) {
      this.loaderTitle = content.title || null
      this.loaderText = content.text || null
      this.loaderDisplayed = true
    },
    hideLoader () {
      this.loaderDisplayed = false
      this.loaderTitle = null
      this.loaderText = null
    }
  },
  mounted () {
    this.$store.dispatch('getSports')
  }
}
</script>

<style lang="scss" scoped>
  .warnings {
    margin-top: 20px;
    color: red;

    .title {
      margin-bottom: 10px;
    }
  }

  pre {
    margin: 20px 0;
    padding: 10px;
    min-height: 50px;
    background-color: #EEE;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Users.vue